import { useEffect, useImperativeHandle, RefObject } from "react";
import { useMutation } from "react-query";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import TextInputContainer from "@containers/TextInputContainer";
import { addOzonApiData, Seller } from "@api/apiClient/sellers";
import { linkVerify } from "@api/apiClient";
import { FormHandle } from "./types";
import styles from './OzonForm.module.scss';

export interface OzonFormType {
  apiKey: string;
  clientId: string;
}

const OzonForm = ({ formRef, seller, onStatusChange, onSuccess, onError }: {
  formRef?: RefObject<FormHandle>;
  onStatusChange: (props: {
    disabled: boolean,
    isLoading?: boolean,
    title?: string,
  }) => void;
  onSuccess: () => void;
  onError: () => void;
  seller: Seller;
}) => {
  const { t } = useTranslation();
  const { control, handleSubmit, formState: { isValid } } = useForm<OzonFormType>({
    defaultValues: {
      apiKey: seller.apiKey,
      clientId: seller.apiClientId,
    },
    // mode: 'onBlur',
  });

  const editMutation = useMutation({
    mutationFn: addOzonApiData,
    onSuccess: () => onSuccess(),
    onError: () => onError(),
  });

  const verifyMutation = useMutation({
    mutationFn: linkVerify,
    onSuccess: () => onSuccess()
  });

  useEffect(() => {
    onStatusChange({
      disabled: !isValid,
      isLoading: Boolean(editMutation.isLoading || verifyMutation.isLoading),
    });
  }, [isValid, editMutation.isLoading, verifyMutation.isLoading])

  const onSubmit = (form: OzonFormType) => {
    editMutation.mutate({
      apiClientId: seller.clientId,
      apiKey: form.apiKey,
      sellerId: seller.id,
    });
  };

  const submit = handleSubmit(onSubmit);

  useImperativeHandle(formRef, () => ({
    submit,
  }));

  return (
    <form
      className={styles.form}
      onSubmit={submit}
    >
      <div className={styles.row}>
        <TextInputContainer
          control={control}
          name="apiKey"
          title={t('storesPage.editShopModal.apiKeyInput')}
          placeholder="API key"
          // hasError={editMutation.isError}
          // error={t('storesPage.editShopModal.apiKeyError')}
          rules={{ required: t("defaultFormErrors.required") }}
          type="text"
          maxLength={999}
        />
        <TextInputContainer
          control={control}
          name="clientId"
          title={t('storesPage.editShopModal.clientIdInput')}
          placeholder="Client ID"
          rules={{ required: t("defaultFormErrors.required") }}
          type="text"
          maxLength={999}
        />
      </div>
    </form>
  )
};

export default OzonForm;
